import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChatWidget } from '@ampersandbrands/ui';
import { createChatClient } from '@/lib/chatClient';
import { useAskStores, useStoreMe, hasStoresHq } from '@/lib/useStores';
import { useSession } from '@/lib/useSession';

// Floating chat on every authed Cockpit page. The shared ChatWidget renders the
// bubble + panel; this wrapper supplies Cockpit's data client and, for a
// store-mapped user, their own store channel so the Ask HQ button/mode targets
// it. HQ / corporate users have no own store, so Ask HQ simply does not show
// (HQ answers questions from the Questions queue, it does not ask them).
// For HQ users (stores:hq) the wrapper also supplies askStores, the store list
// behind the Ask Amp store select, so stock questions can be scoped to a store.
export function ChatBubbleMount() {
  const client = useMemo(() => createChatClient(), []);
  const navigate = useNavigate();
  const me = useStoreMe();
  const storeNo = me.data?.store?.store_no;
  const askHqChannelKey = storeNo != null ? `store:${storeNo}` : null;

  const { user } = useSession();
  const askStoresQ = useAskStores(hasStoresHq(user?.permissions, user?.superAdmin));
  // On fetch failure or an empty list, pass undefined so the widget hides the select.
  const askStores =
    askStoresQ.data && askStoresQ.data.length > 0 ? askStoresQ.data : undefined;

  return (
    <ChatWidget
      client={client}
      askHqChannelKey={askHqChannelKey}
      askStores={askStores}
      onManageNotifications={() => navigate('/settings?tab=notifications')}
    />
  );
}
